var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9,15.2l-4.3-4.3c1-1.2,1.6-2.6,1.6-4.3c0-3.6-2.9-6.6-6.6-6.6S0,2.9,0,6.6s2.9,6.6,6.6,6.6 c1.6,0,3.1-0.6,4.3-1.6l4.3,4.3c0.1,0.1,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1C16,15.7,16,15.4,15.9,15.2z M1,6.6C1,3.5,3.5,1,6.6,1 s5.6,2.5,5.6,5.6s-2.5,5.6-5.6,5.6S1,9.6,1,6.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.603ff7a4c93cf3f366c91306af55bb8f.svg";
export { ForwardRef as ReactComponent };